<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"box-shadow: 0 1px 0 rgba(0,0,0,.14), 0 2px 0 rgba(0,0,0,.05);\n    margin: 0 0 1px 0;"' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.drghafarirad.com\/storage\/contents\/cK2vgAGFcRTw2GYCoS5faosvrYoaQtk96PESySGv.jpg","alt":"mix it web"},...{}}' :style='""' class="w-100 single-banner-image h-100 p-0 m-0" ></m-img><m-nav-302 v-bind='{...{"hideDashboardLink":true,"dashboardLink":"https:\/\/dash.drghafarirad.com\/dashboard"},...{}}' :style='""' class="" ></m-nav-302></template>
                </m-div><m-nav-305 v-bind='{...{"shoppingCartToggleTo":null,"activeSms":false,"navDataToggle":"#nav-305-menu","menuPosition":"blog_footer"},...{}}' :style='""' class="" ></m-nav-305><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"background: #F3F3F3;"' class="" >
                <template #default>   <m-footer-100 v-bind='{...{"menuPosition":"blog_footer"},...{}}' :style='""' class="f-100 py-5" ></m-footer-100></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mNav302 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav302/Nav302'; import mNav305 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav305/Nav305'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mFooter100 from '@moeinmdn/miw-alpha-components/src/package/Footers/Footer100/Footer100';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mNav302,mNav305,mLoading3,mUpdateSiteMessage1,mFooter100 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
